import { FormEvent, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { RiSearchLine } from '@remixicon/react'
import styles from './templates.module.css'

export function Search({
  initialValue = ''
}: {
  initialValue?: string
}): JSX.Element {
  const [value, setValue] = useState(initialValue)
  const router = useRouter()
  useEffect(() => setValue(initialValue), [initialValue])
  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    const keyword = value.trim()
    if (keyword)
      router.push(
        `/templates/search/${encodeURIComponent(keyword)}#template-list`
      )
  }
  return (
    <form
      className={styles.search}
      role="search"
      aria-label="Search templates"
      onSubmit={handleSubmit}
    >
      <RiSearchLine aria-hidden="true" />
      <label className="sr-only" htmlFor="template-search">
        Search templates
      </label>
      <input
        id="template-search"
        type="search"
        name="q"
        value={value}
        onChange={event => setValue(event.target.value)}
        placeholder="Try feedback, registration, or contact…"
        required
      />
      <button type="submit">Search</button>
    </form>
  )
}
